import PropTypes from "prop-types";
import { NftSelect } from "./NftSelect";
import { useEffect, useState } from "react";
import s from "./BurnableSelector.module.css";

const findTokenDataById = (data, match) => {
    /* console.log(
        `findTokenDataById:  data: ${JSON.stringify(data)} match: ${match}`
    ); */

    const result = data.find((obj) => {
        return obj.tokenId == match;
    });

    return result;
};

const BurnableSelector = ({ collectionData, burnables, selectedBurnable }) => {
    const [burnableNfts, setBurnableNfts] = useState([]);

    useEffect(() => {
        const getBurnables = (collectionData, burnables, selectedBurnable) => {
            const ret = Object.entries(burnables)
                .filter((obj) => {
                    return obj[1] > 0;
                })
                .map((obj) => {
                    const data = findTokenDataById(collectionData, obj[0]);
                    //console.log(`data for nftselect = ${JSON.stringify(data)}`);
                    return (
                        <NftSelect
                            key={obj[0]}
                            data={data}
                            balance={obj[1]}
                            select={selectedBurnable}
                        />
                    );
                });

            return ret;
        };

        const data = getBurnables(collectionData, burnables, selectedBurnable);
        setBurnableNfts(data);
        //console.log(`BurnableSelector data: ${JSON.stringify(data)}`);
    }, [collectionData, burnables, selectedBurnable]);

    return (
        <>
            <div className={s.selectTitle}>Select your Burnable!</div>
            <div
                className={s.selectContainer}
                style={
                    burnableNfts.length > 1
                        ? { justifyContent: "space-between" }
                        : { justifyContent: "center" }
                }
            >
                {burnableNfts.length > 0 ? (
                    burnableNfts
                ) : (
                    <div>No elligible burnables!</div>
                )}
            </div>
        </>
    );
};

BurnableSelector.propTypes = {
    collectionData: PropTypes.array,
    burnables: PropTypes.object,
    selectedBurnable: PropTypes.func,
};

export { BurnableSelector };
